export const ESCAPE_KEY_CODE = 27
export const TAB_KEY = 9
export const ENTER_KEY_CODE = 13
export const ENTER_KEY = 'Enter'
export const ESCAPE_KEY = 'Escape'
export const HC_UTM_PARAMS =
  'utm_source=buffer&utm_medium=learn-more-link&utm_campaign=learn-more'
